import apiClient from "../apiClient";

let ControllerName = 'auth';
const AuthController = Object.freeze({
    Login: `${ControllerName}/login`,
    StudentSignUp: `${ControllerName}/student/register`,
    TeacherSignUp: `${ControllerName}/teacher-join-request`,
    AuthMe: `${ControllerName}/me`,
    LogOut: `${ControllerName}/logout`,
});

/**
 * Student Register
 * 
 * This function sends a POST request to the backend to register a new student.
 * @param {Object} userData - The data of the student to be registered (e.g., name, email, password, etc.).
 */
export const StudentSignUp = async (userData) => {
    try {
        // Sending the registration data to the 'student/register' API endpoint
        const response = await apiClient.post(`${AuthController.StudentSignUp}`, userData);
        return response
    } catch (error) {
        if (error.response && error.response.data) {
            const serverMessage = error.response.data.message || 'An error occurred';
            throw new Error(serverMessage); // Throw the error message
          } else {
            // Handle unexpected errors (like network issues)
            throw new Error('An unexpected error occurred. Please try again later.');
          }
       // alert(error);  // Show an alert if there's an error with the request
    }
};

/**
 * Teacher Join Request
 * 
 * This function sends a POST request to the backend to register a new teacher.
 * @param {Object} userData - The data of the teacher to be registered (e.g., name, email, password, etc.).
 */
// export const TeacherSignUp = async (userData) => {
//     try {
//         // Sending the registration data to the 'teacher/join' API endpoint
//         const response = await apiClient.post(`${AuthController.TeacherSignUp}`, userData);
//         return response
//     } catch (error) {
//         if (error.response && error.response.data) {
//             const serverMessage = error.response.data.message || 'An error occurred';
//             throw new Error(serverMessage); // Throw the error message
//           } else {
//             // Handle unexpected errors (like network issues)
//             throw new Error('An unexpected error occurred. Please try again later.');
//           }
//     }
// };
export const TeacherSignUp = async (userData) => {
    try {
        // Sending the registration data to the 'teacher/join' API endpoint
        const response = await apiClient.post(`${AuthController.TeacherSignUp}`, userData);
        return response
    } catch (error) {
        if (error.response && error.response.data) {
            const serverMessage = error.response.data.message || 'An error occurred';
            throw new Error(serverMessage); // Throw the error message
          } else {
            // Handle unexpected errors (like network issues)
            throw new Error('An unexpected error occurred. Please try again later.');
          }
    }
};
/**
 * Login
 * 
 * This function sends a POST request to the backend to log in a user (either student or teacher).
 * @param {Object} userData - The login data (e.g., username, password).
 */
export const userLogin = async (userData) => {
    try {
        // Sending the login credentials to the 'login' API endpoint
       let response = await apiClient.post(`${AuthController.Login}`, userData);
       console.log(response);
       return response
    } catch (error) {
        console.log(error);
        if (error.response && error.response.data) {
            const serverMessage = error.response.data.message || 'An error occurred';
            throw new Error(serverMessage); // Throw the error message
          } else {
            // Handle unexpected errors (like network issues)
            throw new Error('An unexpected error occurred. Please try again later.');
          }
    }
};

/**
 * AuthMe
 * 
 * This function sends a GET request to the backend to fetch the current logged-in user's information.
 * It can be used to check if the user is authenticated and get their profile data.
 */
export const AuthMe = async () => {
    try {
        // Sending the GET request to the 'me' API endpoint to get current user information
        const response = await apiClient.get(`${AuthController.AuthMe}`);
        return response
    } catch (error) {
        console.log(error);  
    }
};

/**
 * Logout
 * 
 * This function sends a POST request to the backend to log out the user.
 * It will invalidate the current session and log the user out.
 */
export const Logout = async () => {
    try {
        // Sending a POST request to the 'logout' API endpoint to log the user out
        const response = await apiClient.post(`${AuthController.LogOut}`, null);
        return response
    } catch (error) {
        console.log(error);  // Show an alert if there's an error with the logout request
    }
};
